import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import CommonTabList from 'components/common/tabs/CommonTabList';
import CommonTabItem from 'components/common/tabs/CommonTabItem';
import DashboardNavBarDropdown from 'components/dashboard/common/DashboardNavBarDropdown';

import './DashboardNavBar.css';


const DashboardNavBar = ({ activePage }) => {
  const { t } = useTranslation();
  const tabs = [
    {
      id: 'links',
      pageName: 'dashboard-links',
      tabName: t('Links'),
      url: '/',
      isMain: true, // it means that tab will be visible on desktop & mobile
    },
    // {
    //   id: 'social_links',
    //   pageName: 'dashboard-social-links',
    //   tabName: t('Social Links'),
    //   mobileTabName: t('Social'),
    //   url: '/social-links',
    //   isMain: true,
    //   additionalClass: 'hidden-xs', // this class hides element on very small device and expand it into dropdown
    // },
    // {
    //   id: 'music_links',
    //   pageName: 'dashboard-music-links',
    //   tabName: t('Music Links'),
    //   labels: 'beta',
    //   url: '/music-links',
    // },
    {
      id: 'appearance',
      pageName: 'dashboard-appearance',
      tabName: t('Appearance'),
      url: '/appearance',
      isMain: true,
    },
    {
      id: 'settings',
      pageName: 'dashboard-settings',
      tabName: t('Settings'),
      url: '/settings',
      isMain: true,
    },
    {
      id: 'analytics',
      pageName: 'dashboard-analytics',
      tabName: t('Analytics'),
      url: '/analytics',
    },
    {
      id: 'earn',
      pageName: 'dashboard-earn',
      tabName: t('Earn'),
      labels: 'beta',
      url: '/earn',
    },
    {
      id: 'store',
      pageName: 'dashboard-store',
      tabName: t('Store'),
      url: '/store',
    },
    {
      id: 'email_signup',
      pageName: 'dashboard-email-signup',
      tabName: t('Signups'),
      url: '/email-signup',
    },
    // {
    //   id: 'integrations',
    //   pageName: 'dashboard-integrations',
    //   tabName: 'Integrations',
    //   labels: 'new',
    //   url: '/integrations',
    // },
    {
      id: 'anonymous_messages',
      pageName: 'dashboard-anonymous-messages',
      tabName: t('Messages'),
      url: '/messages',
    },
  ];

  return (
    <CommonTabList className="dashboard-nav-bar__component">
      {tabs.map(tabItem => (
        <CommonTabItem
          key={`dashboard_nav_bar_item_${tabItem.id}`}
          active={activePage === tabItem.pageName}
          className={
            `nav-item
            ${tabItem.labels ? ` label ${tabItem.labels}` : ''}
            ${tabItem.isMain ? ' main-tab' : ''}
            ${tabItem.additionalClass ? tabItem.additionalClass : ''}`
          }
          tabName={
            tabItem.mobileTabName ?
            <>
              <span className="desktop">{tabItem.tabName}</span>
              <span className="mobile">{tabItem.mobileTabName}</span>
            </>
            :
            tabItem.tabName
          }
          url={tabItem.url}
        />
      ))}

      <DashboardNavBarDropdown
        tabs={tabs}
        activePage={activePage}
      />
    </CommonTabList>
  );
};

DashboardNavBar.propTypes = {
  activePage: PropTypes.string,
};

DashboardNavBar.defaultProps = {
  activePage: null,
};

export default DashboardNavBar;
